"use client";

import { useEffect, useState } from "react";

import { cn } from "@/lib/utils";

export function BgImageOverlay({
  src,
  fallbackSrc,
  className,
  priority = false,
}: {
  src: string;
  fallbackSrc?: string;
  className?: string;
  priority?: boolean;
}) {
  const [resolvedSrc, setResolvedSrc] = useState(src);

  useEffect(() => {
    setResolvedSrc(src);
    if (!fallbackSrc) return;

    const img = new Image();
    img.onerror = () => setResolvedSrc(fallbackSrc);
    img.src = src;
  }, [src, fallbackSrc]);

  if (priority) {
    return (
      // eslint-disable-next-line @next/next/no-img-element
      <img
        src={resolvedSrc}
        alt=""
        aria-hidden
        fetchPriority="high"
        loading="eager"
        decoding="async"
        onError={() => fallbackSrc && setResolvedSrc(fallbackSrc)}
        className={cn(
          "pointer-events-none absolute inset-0 h-full w-full object-cover object-center",
          className,
        )}
      />
    );
  }

  return (
    <div
      aria-hidden
      className={cn(
        "pointer-events-none absolute inset-0 bg-cover bg-center",
        className,
      )}
      style={{ backgroundImage: `url(${resolvedSrc})` }}
    />
  );
}
